import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PwaService {
  private promptEvent: any = null;

  // true se l'app è aperta da standalone/installata
  readonly isStandalone = signal<boolean>(this.checkIfStandalone());

  // true se Chrome/Edge consentono l'installazione tramite popup
  readonly canInstall = signal<boolean>(false);

  constructor() {
    this.initPwa();
  }

  private checkIfStandalone(): boolean {
    const isStandaloneMode = window.matchMedia('(display-mode: standalone)').matches;
    const isIosStandalone = (window.navigator as any).standalone === true;
    return isStandaloneMode || isIosStandalone;
  }

  private initPwa(): void {
    if (this.isStandalone()) {
      return;
    }

    // Intercetta il trigger nativo di Chromium
    window.addEventListener('beforeinstallprompt', (event: Event) => {
      event.preventDefault();
      this.promptEvent = event;
      this.canInstall.set(true);
    });

    // Reset quando l'utente completa l'installazione
    window.addEventListener('appinstalled', () => {
      this.canInstall.set(false);
      this.promptEvent = null;
    });
  }

  async install(): Promise<void> {
    if (!this.promptEvent) return;

    this.promptEvent.prompt();
    const { outcome } = await this.promptEvent.userChoice;

    if (outcome === 'accepted') {
      this.canInstall.set(false);
    }
    this.promptEvent = null;
  }
}
